import Modal from "react-modal";
import { useState } from "react";
import { CreateFalseArray } from "../../Functions/functions";

export default function Modal_false(props) {
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function handleOnChange() {
    // console.log("ischddddddddddddddddecked" ,props.Allcheck.length )
    // let Array_false = [];
    // for(let k =0 ; k< Array_false.length ; k++ ){
    //     Array_false.push(false);
    // }
    // props.setChecked(Array_false);
  }

  function closeModal() {
    props.setIsOpen(false);
    // let darkenedButton = document.getElementsByClassName("darken_btn")[0];

    // darkenedButton.classList.remove("darken_btn");
  }
  var secWrongMessageClass = "secondary_message when_wrong";
  // var  secWrongMessageClassImg = "secondary_message hide_this";
  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;
  var tryAgainText = "";
  var buttonEdit = "";
  var keepPlay = "";
  var mainMessageText = "";

  if (gameLang === "en") {
    mainMessageText = "That is not the right answer!";
    tryAgainText = "Try again";
    buttonEdit = "button-text try-again-english";
    keepPlay = "keep_playing try_again_english";
  } else {
    mainMessageText = "Δεν είναι η σωστή απάντηση!";
    tryAgainText = "Ξαναπροσπάθησε";
    buttonEdit = "button-text try-again-english";
    keepPlay = "keep_playing try_again";
  }

  return (
    <div className="modal_container false">
      <div className="background_image"></div>
      <div className="face_sketch">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="128"
          height="128"
          viewBox="0 0 128 128"
        >
          <g
            id="Group_542"
            data-name="Group 542"
            transform="translate(-656.917 -552.268)"
          >
            <circle
              id="Ellipse_113"
              data-name="Ellipse 113"
              cx="64"
              cy="64"
              r="64"
              transform="translate(656.917 552.268)"
              fill="#f3f3f3"
            />
            <g
              id="Group_339"
              data-name="Group 339"
              transform="translate(-4544.333)"
            >
              <g id="Group_338" data-name="Group 338">
                <path
                  id="Path_1173"
                  data-name="Path 1173"
                  d="M5265.25,578.568a36.9,36.9,0,1,1-36.9,36.9,36.95,36.95,0,0,1,36.9-36.9m0-3.6a40.5,40.5,0,1,0,40.5,40.5,40.446,40.446,0,0,0-40.5-40.5Zm-17.1,24.75c-2.52,0-4.5,2.61-4.5,5.85s1.98,5.85,4.5,5.85,4.5-2.61,4.5-5.85S5250.67,599.718,5248.15,599.718Zm34.2,0c-2.52,0-4.5,2.61-4.5,5.85s1.98,5.85,4.5,5.85,4.5-2.61,4.5-5.85S5284.87,599.718,5282.35,599.718Zm1.89,37.8a1.827,1.827,0,0,0,.18-2.52,25.5,25.5,0,0,0-38.34-.09,1.786,1.786,0,1,0,2.7,2.34,22.359,22.359,0,0,1,16.47-7.38,21.8,21.8,0,0,1,16.47,7.47,1.913,1.913,0,0,0,1.35.63A1.712,1.712,0,0,0,5284.24,637.518Z"
                  fill="#222"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className="main_message">{mainMessageText}</div>
      <div className={secWrongMessageClass}>{/*{props.answer}*/}</div>
      {/*<div className={secWrongMessageClassImg}><img src={`img/${props.answer}`} /></div>*/}
      <button
        className={keepPlay}
        onClick={() => {
          handleOnChange();
          closeModal();
        }}
      >
        <span className={buttonEdit}>{tryAgainText}</span>
      </button>
    </div>
  );
}
